import React, { useEffect, useRef } from 'react';
import { useGlobalState } from '../contexts/GlobalStateContext.tsx';
import type { User } from '../types.ts';

const GOOGLE_CLIENT_ID = '555179712981-36hlicm802genhfo9iq1ufnp1n8cikt9.apps.googleusercontent.com';

export const LoginView: React.FC = () => {
    const { dispatch } = useGlobalState();
    const signInButtonRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleCredentialResponse = (response: any) => {
            // Decode JWT to get user info
            const idToken = response.credential;
            const payload = JSON.parse(atob(idToken.split('.')[1]));
            
            const user: User = {
                name: payload.name,
                email: payload.email,
                picture: payload.picture,
            };

            dispatch({ type: 'LOGIN', payload: user });
        };

        if (window.google) {
            window.google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: handleCredentialResponse,
            });

            if (signInButtonRef.current) {
                 window.google.accounts.id.renderButton(
                    signInButtonRef.current,
                    { theme: 'outline', size: 'large', type: 'standard', text: 'signin_with' }
                );
            }
        }
    }, [dispatch]);

    return (
        <div className="h-screen w-screen flex items-center justify-center bg-background text-text-primary">
            <div className="bg-surface p-8 sm:p-12 rounded-2xl shadow-2xl text-center border border-border animate-pop-in">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary mx-auto mb-4">
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <h1 className="text-3xl font-extrabold tracking-tight mb-2">Welcome to DevCore AI</h1>
                <p className="text-text-secondary mb-8">Sign in to continue to your toolkit.</p>
                <div id="googleSignInButton" ref={signInButtonRef} className="flex justify-center"></div>
            </div>
        </div>
    );
};